import type { Position } from 'geojson';

export const isGeojsonPosition = (coordinate: any): coordinate is Position => {
  return (
    Array.isArray(coordinate) &&
    coordinate.length >= 2 &&
    typeof coordinate[0] === 'number' &&
    typeof coordinate[1] === 'number'
  );
};
